// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type AboutItemProps = {
  name: string;
  title: string;
  description: string;
  className: string;
};

const AboutItem = (props: AboutItemProps) => {
  const { name, title, description, className } = props;
  const t = useTranslate();

  return (
    <div className={className}>
      <div className="AboutItem">
        <span className="AboutItem__name">{t(name)}</span>
        <span className="AboutItem__title">{t(title)}</span>
        <span className="AboutItem__description">{t(description)}</span>
      </div>
    </div>
  );
};

export default AboutItem;
